function addFileUploaderData(form, formData) {
    form.find('input[type="file"]').each(function () {
        var input = $(this);
        if (input.hasClass("inp-file-basic") || input.hasClass("inp-file-extended")) {
            var files = $.filesUploader.getFiles(input);
            var name = input.attr("name");
            if (files.length > 1) {
                for (var i = 0; i < files.length; i++) {
                    formData.append(name + "[]", files[i]);
                }
            } else {
                if (files.length === 1) {
                    formData.append(name, files[0]);
                }
            }
        }
    });
}

const FileRenderer = function () {
    var loadImagePreview = function (file, callback) {
        var fileInfo = getFileInfo(file);
        if(fileInfo.extension.match(/jpg|gif|png|jpeg/gi)){
            loadImageFromFile(file, function (img) {
                callback(img);
            });
        } else {
            var image_url = PATHS.icons + "files_types/";
            var image = fileInfo.extension + ".png";
            var img = new Image();
            img.height = 250;
            imageExists(image_url + image, function (result) {
                img.src = result ? image_url + image : image_url + "others.png";
                callback(img);
            });
        }
    };

    this.renderTile = function (file, editable, callback) {
        var fileInfo = getFileInfo(file);
        loadImagePreview(file, function (img) {
            img.title = fileInfo.basename;
            img.alt = fileInfo.basename;
            callback('' +
                '<div class="preview editor preview-' + file.id + '">' +
                '<div class="mnavbar options-bar' + (editable ? "" : " displ-none") + '">' +
                '<div class="mnavbar-group"><div class="mnavbar-item"><a data-id="' + file.id + '" class="option preview-remove" title="Odebrat soubor"><i class="fa fa-times"></i></a></div></div>' +
                '</div>' +
                '<div class="edit-content">' +
                '<div class="title preview-title absolute bottom highlighted"><span>' + fileInfo.basename + '</span></div>' +
                $(img).fadeIn().prop('outerHTML') +
                '</div>' +
                '</div>');
        });
    };

    this.renderTableRow = function (file, editable) {
        var fileInfo = getFileInfo(file);
        return '<tr class="preview preview-'+file.id+' editor-row">' +
            '<td class="preview-title"><span>' + fileInfo.basename + '</span></td>' +
            '<td>' + fileInfo.size.toFixed(2) + ' MB</td>' +
            '<td class="progress-cell"></td>'+
            '<td class="shrink preview-options editor-options '+(editable ? "" : "displ-none")+'"><div class="options-bar transparent"><div class="group"><a data-id="'+file.id+'" class="option preview-remove"><i class="fa fa-remove"></i></a></div></div>' +
            '</td>' +
            '</tr>';
    };
};

const Uploader = function(settings) {

    var default_settings = {
        MaxFiles: 0,
        maxPostSize: 0,
        maxFileSize: 0,
        disabled: undefined,
        allowedExt: undefined,
        preUpload: false,
        rendererType: "basic",
        uploadUrl: ""
    };

    if(isDefined(settings)) {
        parseOptions(default_settings, settings);
    }

    var idCounter = 1;
    var editable = 0;
    var filesToUpload = [];
    var totalSize = 0;
    var messages = {
        allowedExtensions: "Povolené přípony",
        maxFiles: "Maximální počet souborů",
        fileMaxSize: "maximální velikost souboru",
        allFilesMaxSize: "Maximální velikost všech souborů",
        help: "Nápověda",
        selectFiles: "Vyberte soubor/y kliknutím do plochy nebo přetáhnutím souborů do plochy",
        notAllowed: "Přípona souboru <b>{file}</b> nepatří mezi povolené",
        alreadyInserted: "Soubor <b>{file}</b> už je vložený",
        maxCountExceeded: "Byl překročen maximální počet souborů",
        maxSizeExceeded: "Byl překročen limit celkové velikosti všech souborů",
        isTooLarge: "Soubor <b>{file}</b> je příliš velký"
    };
    var errors = "";
    var previewType = "tiles";
    var input = null;

    var findFilename = function (name) {
        for (var i = 0; i < filesToUpload.length; i++) {
            var basename = filesToUpload[i].name.replace(/\\/g, '/').replace(/.*\//, '');
            if (basename === name) {
                return i;
            }
        }
        return -1;
    };

    var findFileById = function(id) {
        var index = -1;
        $.each(filesToUpload, function (i,file) {
            if(file.id === id){
                index = i;
            }
        });
        return index;
    };

    this.getMessage = function (name) {
        return messages[name];
    };

    this.setInput = function (input_obj) {
        input = input_obj;
    };

    this.moveToContainer = function (target) {
        target = target.closest(".file-uploader");
        if (target.length) {
            return target;
        }
        return undefined;
    };

    this.moveToBody = function (target) {
        target = this.moveToContainer(target);
        if (isDefined(target)) {
            return target.find(".uploader-body");
        }
        return target;
    };

    var buildHelpMessage = function () {
        var allowed = "";
        if (isDefined(default_settings[4])) {
            allowed = ", <br />" + messages.allowedExtensions + ": <b>" + default_settings[4].replace(/[|]/g, ", ") + "</b>";
        } else {
            default_settings[4] = "";
        }
        return '' + messages.maxFiles + ': ' + default_settings[0] + ', <br />' + messages.maxFileSize + ': ' + (default_settings[2] / 1024) / 1024 + ' MB,<br /> ' + messages.allFIlesMaxSize + ': ' + (default_settings[1] / 1024) / 1024 + ' MB' + allowed + '';
    };

    var checkInsertedFile = function (file) {

        var fileData = getFileInfo(file);

        if (default_settings.allowedExt.indexOf(fileData.extension) < 0) {
            errors += str_replace(messages.notAllowed, "\{file\}", fileData.basename) + "<br />";
            return;
        }

        if (fileData.size <= default_settings.maxFileSize) {
            if ((totalSize + fileData.size) <= default_settings.maxPostSize) {
                if (filesToUpload.length < default_settings.MaxFiles) {
                    if (findFilename(fileData.basename) < 0) {
                        this.sizeChecker += fileData.fileSize;
                        file.id = idCounter;
                        idCounter++;
                        filesToUpload.push(file);
                    } else {
                        errors += str_replace(messages.alreadyInserted, "\{file\}", fileData.basename) + "<br />";
                    }
                } else {
                    errors += messages.maxCountExceeded + "<br />";
                    return false;
                }
            } else {
                errors += messages.maxSizeExceeded + "<br />";
                return false;
            }
        } else {
            errors += str_replace(messages.isTooLarge, "\{file\}", fileData.basename) + "<br />";
        }

    };

    var checkFiles = function (files) {
        var that = this;
        $.each(files, function (i, f) {
            if(isBoolean(checkInsertedFile(f))){
                return false;
            }
        });

        if (errors !== '') {
            new AlertDialog({
                buttonPointer: false,
                message: errors
            });
            errors = '';
        }
    };

    this.setFiles = function (files) {
        checkFiles(files);
    };

    this.changeSettings = function (settings) {
        if (isDefined(settings)) {
            parseOptions(this.settings, settings);
        }
    };

    this.enableEdit = function (enable) {

        var body = this.moveToBody(input);
        var content = body.find(".uploader-content");
        var mnavbars = body.find(".uploader-previews").find(".mnavbar");

        if (enable) {
            content.find('input[type="file"]').last().hide();
            mnavbars.removeClass("displ-none");
            editable = 1;
        } else {
            content.find('input[type="file"]').last().show();
            mnavbars.addClass("displ-none");
            editable = 0;
        }
    };

    this.clearPreviews = function () {
        var body = this.moveToBody(input);
        body.find(".uploader-previews").html("");
    };

    this.switchMode = function (mode) {
        previewType = mode;
        this.renderArea(this.moveToBody(input).find(".uploader-previews"));
    };

    var uploadFile = function (progressArea, file, callback) {

        var progressBar = $.progressBar.insert(progressArea);

        var formData = new FormData();
        formData.append(input.attr("name"), file);

        $.nette.ajax({
            xhr: function () {
                let xhr = new window.XMLHttpRequest;

                xhr.upload.addEventListener('progress', function(e) {
                    if (e.lengthComputable) {
                        let percentComplete = e.loaded / e.total;
                        $.progressBar.update(progressBar, Math.round(percentComplete * 100));
                    }
                }, false);

                return xhr;
            },
            type: "POST",
            url: default_settings.uploadUrl,
            data: formData,
            processData: false,
            contentType: false,
            success: function () {
                $.progressBar.remove(progressBar);
                callback(true);
            }
        });

    };

    this.renderPreviews = function (previewsTarget, renderAgain) {

        renderAgain = renderAgain | false;

        var self = this;
        var fileRenderer = new FileRenderer();

        switch (previewType) {
            case "tiles":

                if(!previewsTarget.find(".tiles-previews").length){
                    previewsTarget.append('<div class="tiles-previews"></div>');
                }

                previewsTarget.find(".table-previews").hide();
                var tilesPreviews = previewsTarget.find(".tiles-previews");
                tilesPreviews.show();

                $.each(filesToUpload, function (i, file) {
                    if (!isBoolean(file.tileRendered) || renderAgain) {
                        fileRenderer.renderTile(file, editable, function (tile) {
                            tile = $(tile);
                            tilesPreviews.append(tile);

                            if (default_settings.preUpload) {
                                tile.append('<div class="edit-content"></div>');
                                var progressTarget = tile.find(".edit-content").last();
                                if(!isBoolean(file.uploaded)) {
                                    uploadFile(progressTarget, file, function (result) {
                                        if(result){
                                            var msgGroup = $.inlineMessages.createGroup(progressTarget);
                                            $.inlineMessages.insertMessage(msgGroup, "Nahráno");
                                            self.adjustInput();
                                        }
                                    });
                                } else {
                                    var msgGroup = $.inlineMessages.createGroup(progressTarget);
                                    $.inlineMessages.insertMessage(msgGroup, "Nahráno");
                                }
                            }

                            tile.find(".preview-remove").on("click", function (e) {
                                self.removeFile(file.id, previewsTarget);
                            });
                            file.tileRendered = true;
                            self.adjustInput();
                        });
                    }
                });
                break;
            case "table":

                if(!previewsTarget.find(".table-previews").length){
                    previewsTarget.append('<div class="table-previews"></div>');
                }
                previewsTarget.find(".tiles-previews").hide();
                var tablePreviews = previewsTarget.find(".table-previews");
                tablePreviews.show();

                var content;

                if (tablePreviews.html() === "") {
                    content = $('<table class="editor"><tbody></tbody></table>');
                    tablePreviews.append(content);
                } else {
                    content = tablePreviews.find(".block");
                }

                $.each(filesToUpload, function (i, file) {
                    if (!isBoolean(file.tableRendered) || renderAgain) {
                        var row = $(fileRenderer.renderTableRow(file, editable));
                        content.find("table tbody").append(row);
                        var progressTarget = row.find(".progress-cell");

                        if (default_settings.preUpload) {
                            if(!isBoolean(file.uploaded)) {
                                uploadFile(progressTarget, file, function (result) {
                                    if(result){
                                        var msgGroup = $.inlineMessages.createGroup(progressTarget);
                                        $.inlineMessages.insertMessage(msgGroup, "Nahráno");
                                        self.adjustInput();
                                    }
                                });
                            } else {
                                var msgGroup = $.inlineMessages.createGroup(progressTarget);
                                $.inlineMessages.insertMessage(msgGroup, "Nahráno");
                            }
                        }

                        row.find(".preview-remove").on("click", function (e) {
                            self.removeFile(file.id, previewsTarget);
                        });

                        self.adjustInput();
                        file.tableRendered = true;
                    }
                });

                this.adjustInput();

                break;
            default:
                console.log("wrong uploader render type in graphicsRenderer");
                break;
        }

    };

    this.renderArea = function (previewsTarget) {

        previewsTarget.find(".choose-file").remove();

        if (default_settings.rendererType === "basic") {
            if (filesToUpload.length > 0) {
                previewsTarget.text("Vybráno " + filesToUpload.length + " souborů");
                previewsTarget.parent().find(".options-bar").removeClass("displ-none");
            } else {
                previewsTarget.text("Vyberte soubor/y");
                previewsTarget.parent().find(".options-bar").addClass("displ-none");
            }
        } else {
            if (filesToUpload.length > 0) {
                this.renderPreviews(previewsTarget);
            } else {
                previewsTarget.html('<div class="choose-file"><div class="title align-center"><span>' + messages.selectFiles + '</span></div>');
            }
        }

    };

    this.adjustInput = function () {
        input.attr('style', 'width: 100%; height: '+getContainerHeight(this.moveToBody(input))+'px !important');
    };

    this.removeFile = function(id, previewsDest) {

        var index = findFileById(id);
        var self = this;

        if (index >= 0) {
            totalSize -= filesToUpload[index].size;
            filesToUpload.splice(index, 1);
            previewsDest.find(".preview-"+id+"").fadeOut(300, function () {
                $(this).remove();
                self.renderArea(self.moveToBody(input).find(".uploader-previews"));
            });
        }
    };

    this.getFiles = function (input) {
        return filesToUpload;
    };

    this.clear = function (target) {
        var container = this.moveToContainer(target);
        totalSize = 0;
        filesToUpload = [];
        errors = "";
        this.clearPreviews();
        var input = container.find("input[type=file]");
        var clone = input.val('').clone(true);
        input.replaceWith(clone);
    };

};

(function ($) {

    $.fn.optimusEditor = function (clickedOptionCallback, clickedButtonCallback) {

        var container = $(this);
        var Editor;

        function initEditorOptions(target) {

            target.find(">.mnavbar.options-bar .mnavbar-group, table .editor-row .editor-col > .mnavbar.options-bar .mnavbar-group").each(function () {

                let group = $(this);
                let iterator = 1;

                group.find(".option").each(function () {
                    $(this).data("optionIndex", iterator);
                    iterator++;
                }).on("click", function (e) {

                    var option = $(this);

                    if (group.hasClass("single-active")) {
                        option.siblings().removeClass("active");
                        if (option.hasClass("active")) {
                            option.removeClass("active");
                        } else {
                            option.addClass("active");
                        }
                    } else if (group.hasClass("multi-active")) {
                        if (option.hasClass("active")) {
                            option.removeClass("active");
                        } else {
                            option.addClass("active");
                        }
                    } else {
                        console.log("No group type defined");
                    }
                });
            });
        }

        function makeNewEventsOnOptions(target, callback) {
            target.find(">.mnavbar.options-bar .mnavbar-group .option, table .editor-row .editor-col .mnavbar.options-bar .mnavbar-group .option").on("click", function (e) {
                console.log($(this));
                var option = $(this);
                option.optionIndex = option.data("optionIndex");
                callback(option, e);
            });
        }

        function detectEditorContentButtons(target, callback) {
            target.find('a.button, input[type="submit"]').on("click", function (e) {
                callback($(this), e);
            });
        }

        if (container.hasClass("editor")) {

            var instance;

            if (!isDefined(container.data("instance"))) {

                Editor = {
                    container: container,
                    firstInit: true,

                    moveToContent: function (target) {
                        if(target.find(">.edit-content").length){
                            return target.find(">.edit-content");
                        } else {
                            return target.find(".editor-table");
                        }
                    },

                    init: function () {
                        let self = this;

                        initEditorOptions(self.container);
                        if (isFunction(clickedOptionCallback)) {
                            makeNewEventsOnOptions(self.container, function (option, event) {
                                clickedOptionCallback(option, event, self.moveToContent(self.container));
                            });
                        }
                        if (isFunction(clickedButtonCallback)) {
                            detectEditorContentButtons(self.moveToContent(self.container), function (btn, event) {
                                clickedButtonCallback(btn, event, self.moveToContent(self.container));
                            });
                        }

                    }
                };

                Editor.init();
                container.data("instance", Editor);

            } else {

                instance = container.data("instance");

                if(instance.firstInit) {

                    if (isFunction(clickedOptionCallback)) {
                        makeNewEventsOnOptions(instance.container, function (option, event) {
                            clickedOptionCallback(option, event, instance.moveToContent(instance.container));
                        });
                    }

                    if (isFunction(clickedButtonCallback)) {
                        detectEditorContentButtons(instance.moveToContent(instance.container), function (btn, event) {
                            clickedButtonCallback(btn, event, instance.moveToContent(instance.container));
                        });
                    }

                    instance.firstInit = false;
                    container.data("instance",instance);
                }
            }
        }

    };

    $.fn.inputFileUpload = function (settings) {

        if (!window.File && !window.FileList && !window.FileReader) {
            return;
        }

        if (!isDefined(settings)) {
            settings = {
                rendererType: "basic"
            }
        }

        var input = $(this);

        if (!isDefined(input.data("instance"))) {

            var uploaderInstance;

            switch (settings.rendererType) {
                case "basic":
                    let body = input.closest(".uploader-body");
                    if (!input.closest(".uploader-body").length) {
                        input.wrap('<div class="uploader-body"></div>');
                        body = input.closest(".uploader-body");
                    }
                    if (!body.closest(".inp-uploader-wrap").length) {
                        body.wrap('<div class="inp-wrap inp-uploader-wrap file-uploader"></div>');
                    }
                    body.prepend('<div class="uploader-previews">Vyberte soubor/y</div>');
                    body.append('<div class="mnavbar options-bar transparent displ-none"><div class="mnavbar-group"><div class="mnavbar-item icon-link"><a class="uploader-edit option rounded"><i class="fa fa-edit"></i></a></div></div></div>');

                    uploaderInstance = new Uploader($.extend(input.data("limits"), settings));
                    uploaderInstance.setInput(input);

                    body.find(".uploader-edit").on("click", function (e) {
                        e.preventDefault();
                        var btn = $(this);
                        new BasicDialog({
                            bar: {
                                title: "Editace souborů"
                            },
                            content: " ",
                            event: e,
                            buttonPointer: btn,
                            classes: {
                                container: "basic-uploader-dialog"
                            }
                        }, function (dialog, dialogInstance) {
                            body = dialogInstance.moveToBody(dialog);
                            uploaderInstance.enableEdit(true);
                            uploaderInstance.renderPreviews(body, true);
                        });
                    });

                    break;
                case "graphics":

                    uploaderInstance = new Uploader($.extend(input.data("limits"), settings));

                    var construction = $('' +
                        '<div class="editor file-uploader">' +
                        '<div class="mnavbar options-bar uploader-options">' +
                        '<div class="mnavbar-group single-active">' +
                        '<div class="mnavbar-item icon-link"><a class="uploader-edit option" title="Editovat soubory">' +
                        '<i class="fa fa-edit fa-editor"></i>' +
                        '</a></div>' +
                        '</div>' +
                        /*'<div class="mnavbar-group single-active">' +
                        '<div class="mnavbar-item icon-link"><a class="uploader-tiles option active" title="Zobrazit dlaždice">' +
                        '<img src="' + PATHS.icons + 'graphics.png" title="graphics" alt="graphics">' +
                        '</a></div>' +
                        '<div class="mnavbar-item icon-link"><a class="uploader-table option" title="Zobrazit tabulku">' +
                        '<img src="' + PATHS.icons + 'table.png" title="table" alt="table">' +
                        '</a></div>' +
                        '</div>' +*/
                        '</div>' +
                        '<div class="edit-content">' +
                        '<div class="uploader-body">' +
                        '<div class="uploader-previews"></div>' +
                        '<div class="uploader-content">' +
                        input.prop('outerHTML') +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>');

                    input.replaceWith(construction);
                    input = construction.find('input[type="file"]');
                    uploaderInstance.setInput(input);
                    uploaderInstance.renderArea(uploaderInstance.moveToBody(input).find(".uploader-previews"));

                    var editor = input.closest(".editor");

                    editor.optimusEditor(function (option) {
                        if (option.hasClass("uploader-edit")) {
                            uploaderInstance.enableEdit(option.hasClass("active"));
                        } else if (option.hasClass("uploader-tiles")) {
                            uploaderInstance.switchMode("tiles");
                        } else if (option.hasClass("uploader-table")) {
                            uploaderInstance.switchMode("table");
                        }
                    });

                    break;
            }

            input.on("change", function (e) {
                if (!$(e.target).is(".uploader-previews")) {
                    var input = $(this);
                    var files = this.files;

                    uploaderInstance.setFiles(files);
                    uploaderInstance.renderArea(uploaderInstance.moveToBody(input).find(".uploader-previews"));

                    var clone = input.val('').clone(true);
                    input.replaceWith(clone);
                    uploaderInstance.setInput(clone);
                }
            });

            input.on("drop", function (e) {
                e.preventDefault();
                var files = e.originalEvent.dataTransfer.files;
                uploaderInstance.setFiles(files);
                uploaderInstance.renderArea(uploaderInstance.moveToBody(input).find(".uploader-previews"));
            });

            uploaderInstance.adjustInput();

            input.data("instance", uploaderInstance);

        } else {

        }

    };
})(jQuery);

(function (window, $, undefined) {

    if (typeof $ !== 'function') {
        return console.error('$.dialog: jQuery is missing, load it please');
    }

    $.filesUploader = {

        isFileInput: function (input) {
            return input.attr("type") === "file";
        },

        getInstance: function (input) {
            if (!this.isFileInput(input)) {
                console.error("input type is not file");
                return null;
            }
            if (isDefined(input.data("instance"))) {
                return input.data("instance");
            }
            console.log("input hasn't got FileUploader instance");
            return null;
        },

        moveToContainer: function (input) {
            var instance = this.getInstance(input);
            return instance.moveToContainer(input);
        },

        moveToBody: function (input) {
            var instance = this.getInstance(input);
            return instance.moveToBody(input);
        },

        getFiles: function (input) {
            var instance = this.getInstance(input);
            if (isDefined(instance) && instance !== null) {
                return instance.getFiles(input);
            } else {
                return [];
            }
        },

        clear: function (input) {
            var instance = this.getInstance(input);
            if (isDefined(instance) && instance !== null) {
                instance.clear(input);
            }
        }

    };

})(window, window.jQuery);